import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const BlacklistApi = {
    search: (query?: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['blacklist', 'search', query || ''], (api) => api.blacklist.search(query), options),
    remove: (options?: BaseApiMutationOptions<ApiClient['blacklist']['remove']>) => apiMutationOptions((api) => api.blacklist.remove, options)
};
